import { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import * as Yup from 'yup'
import { updateArticuloPrecio } from '../../../Services/articuloPrecioService'

const validationSchema = Yup.object().shape({
  precio: Yup.number()
    .required('El precio es obligatorio')
    .min(0, 'El precio debe ser mayor o igual a 0'),
})

const useEditArticuloPrecio = (history, match) => {
  const [initialValues, setInitialValues] = useState({
    codigoArticulo: '',
    precio: '',
  })
  const [articuloId, setArticuloId] = useState('')
  const [listaPrecioId, setListaPrecioId] = useState('')

  useEffect(() => {
    const { articuloId, listaPrecioId } = match.params
    setArticuloId(articuloId)
    setListaPrecioId(listaPrecioId)

    // Obtenemos los datos del state que pasamos en el history.push
    const locationState = history.location.state
    if (locationState && locationState.codigoArticulo && locationState.precio) {
      setInitialValues({
        codigoArticulo: locationState.codigoArticulo,
        precio: locationState.precio,
      })
    } else {
      // Si no hay state (por ejemplo, si recarga la página), redirigir a la lista de precios
      history.push('/articulo-precios')
    }
  }, [match.params, history])

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      await updateArticuloPrecio(articuloId, listaPrecioId, { precio: values.precio })
      Swal.fire({
        type: 'success',
        title: 'Precio actualizado',
        text: 'El precio del artículo fue actualizado correctamente.',
        timer: 2000,
        showConfirmButton: false,
      })
      history.goBack()
    } catch (error) {
      Swal.fire({
        type: 'error',
        title: 'Error',
        text: 'No se pudo actualizar el precio. Intente nuevamente.',
      })
      setSubmitting(false)
    }
  }
  return {
    initialValues,
    validationSchema,
    handleSubmit
  }
}

export default useEditArticuloPrecio